import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { PpmService } from '../ppm.service';
import { getPpmHistoryDataTableStructure } from './utils/ppm-history.data-table';
import { PageHeaderComponent } from '../../../components/shared/page-header/page-header.component';
import { ButtonModule } from 'primeng/button';
import { Router } from '@angular/router';
import { DataTableBuilderComponent } from '../../../components/data-table-builder/data-table-builder.component';
import { DataTableRowActions, DynamicDataTable } from '../../../components/data-table-builder/data-table.types';
import { Ppm } from '@/types';
import { DialogComponent } from '../../../components/dialog/dialog.component';
import { DialogObject } from '../../../components/dialog/dialog.types';
import { MessageService } from 'primeng/api';
import { PpmRepository } from '../../../store/ppm-state/ppm-state.repository';

@Component({
  selector: 'sm-ppm-history',
  templateUrl: './history.component.html',
  styleUrl: './history.component.scss',
  imports: [PageHeaderComponent, DataTableBuilderComponent, ButtonModule],
})
export class PpmHistoryComponent implements OnInit {
  ppmService = inject(PpmService);
  ppmRepository = inject(PpmRepository);
  router = inject(Router);
  messageService = inject(MessageService);

  breadcrumb = [
    {
      label: 'ppm.pages.full_history',
      routerLink: ['/ppm-history'],
    },
  ];

  @ViewChild('dialog') dialogComponent!: DialogComponent;
  ppmDialog?: DialogObject;

  rowActions: DataTableRowActions = {
    defaultActions: {
      inspect: {
        label: 'ppm.actions.inspect',
      },
    },
    inspectAction: (row: Ppm) => {
      this.router.navigate([`ppm-inspect-plan/${row.id}`]);
    },
  };

  loading = true;
  data: Ppm[] = [];
  datatableObject: DynamicDataTable = getPpmHistoryDataTableStructure({
    store: this.ppmRepository,
    rowActions: this.rowActions,
  });

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    this.ppmService.getPpms().subscribe({
      next: data => {
        this.data = data.content;
        this.loading = false;
      },
      error: err => {
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: err.error.message || 'Une erreur est survenue lors de la récupération des ppms',
        });
      },
    });
  }

  redirectNewPpmNotice() {
    this.router.navigate(['/ppm-new-plan']);
  }
}
